import type { PageContext } from 'vike/types';
import { TAX_ICEBERG_LEGACY_SEGMENT, TAX_ICEBERG_PATHS } from '../../utils/salary/tax-iceberg-url';

const SEGMENTS = new Set<string>([...Object.values(TAX_ICEBERG_PATHS), TAX_ICEBERG_LEGACY_SEGMENT]);

/**
 * `/{segment}` (the default view) and `/{segment}/{salary-slug}` where the segment is the
 * locale's translated one (`veroprosenttilaskuri`, `loneraknare`, `tax-iceberg`). The locale
 * prefix is stripped by +onBeforeRoute, which puts the logical path in `urlLogical`, so the
 * route accepts every locale's segment here; +guard.ts then 301s a segment or salary slug that
 * is not the canonical form for the page's locale, and 404s a slug that does not parse.
 */
export function route(pageContext: PageContext) {
  const raw = ((pageContext as { urlLogical?: string }).urlLogical ?? pageContext.urlPathname ?? '').split('?')[0].replace(/\/+$/, '');
  const m = /^\/([^/]+)(?:\/([^/]+))?$/.exec(raw);
  if (!m || !SEGMENTS.has(m[1])) return false;
  return { routeParams: { segment: m[1], ...(m[2] ? { slug: decodeURIComponent(m[2]) } : {}) } };
}
